export default "__VITE_ASSET__c1128e1a__"